"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BillCalculatorTotal = exports.BillCalculatorItem = exports.BillCalculator = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formik = require("formik");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Button = _interopRequireDefault(require("../Button"));
var _StripeFields = _interopRequireDefault(require("./StripeFields"));
var _utils = require("./utils");
var PaymentWithCalculator = function PaymentWithCalculator(_ref) {
  var isOpen = _ref.isOpen,
    isLoading = _ref.isLoading,
    toggle = _ref.toggle,
    description = _ref.description,
    interval = _ref.interval,
    paymentMethod = _ref.paymentMethod,
    stripe = _ref.stripe,
    onCancel = _ref.onCancel,
    _onSubmit = _ref.onSubmit,
    calculator = _ref.calculator,
    error = _ref.error;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: "lg",
    open: isOpen,
    onClose: function onClose() {
      return isOpen && toggle();
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactStripeJs.Elements, {
    stripe: stripe
  }, /*#__PURE__*/_react["default"].createElement(_reactStripeJs.ElementsConsumer, null, function (_ref2) {
    var elements = _ref2.elements,
      stripe = _ref2.stripe;
    return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
      validationSchema: !paymentMethod && _utils.validationSchema,
      initialValues: {
        name: '',
        postalCode: ''
      },
      onSubmit: function onSubmit(_ref3) {
        var name = _ref3.name,
          postalCode = _ref3.postalCode;
        if (!(0, _isNil["default"])(paymentMethod)) {
          return _onSubmit();
        }
        var cardElement = elements.getElement(_reactStripeJs.CardNumberElement);
        _onSubmit({
          stripe: stripe,
          cardElement: cardElement,
          name: name,
          postalCode: postalCode
        });
      }
    }, function (_ref4) {
      var errors = _ref4.errors,
        touched = _ref4.touched,
        isValid = _ref4.isValid;
      var fieldOrder = ['name', 'cardNumber', 'cvc', 'expiry', 'postalCode'];

      // Payment on the left
      var left = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "text-2xl text-dark font-bold mb-5"
      }, t('premium.billCalculator.headers.subscriptionOrder')), /*#__PURE__*/_react["default"].createElement("h3", {
        className: "text-dark font-bold mb-3"
      }, t("premium.billCalculator.headers.interval.".concat(interval))), /*#__PURE__*/_react["default"].createElement("p", {
        className: "mb-5 text-medium"
      }, description), /*#__PURE__*/_react["default"].createElement("h3", {
        className: "text-dark font-bold mb-3"
      }, t('premium.billCalculator.headers.paymentMethod')), paymentMethod ? /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-medium capitalize"
      }, paymentMethod) : /*#__PURE__*/_react["default"].createElement(_StripeFields["default"], {
        errors: errors,
        touched: touched,
        fieldOrder: fieldOrder
      }));
      var loader = /*#__PURE__*/_react["default"].createElement("div", {
        className: "absolute w-full h-full flex items-center justify-center -m-8"
      }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null));
      return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
        className: "p-12"
      }, isLoading && loader, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('w-full h-full flex justify-between', {
          'mb-48': !!paymentMethod,
          'opacity-0': isLoading
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-1/2 pr-8"
      }, left), /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-1/2"
      }, calculator)), error, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'opacity-0': isLoading
        })
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        type: "button",
        color: "secondary",
        className: "py-5 mr-5 w-1/4",
        onClick: onCancel
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        type: "submit",
        className: "py-5 w-1/4",
        disabled: !paymentMethod && !isValid || isLoading
      }, t('premium.billCalculator.confirmPlanChange'))));
    });
  })));
};
var BillCalculator = exports.BillCalculator = function BillCalculator(_ref5) {
  var name = _ref5.name,
    interval = _ref5.interval,
    children = _ref5.children;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-12"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "shadow-lg dark:bg-secondary dark:shadow-shallow"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-primary text-white py-8 px-5"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "font-bold text-2xl"
  }, t('premium.billCalculator.planName', {
    name: name
  })), /*#__PURE__*/_react["default"].createElement("p", null, t("premium.billCalculator.headers.interval.billed.".concat(interval)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-8 px-5"
  }, children)));
};
var BillCalculatorItem = exports.BillCalculatorItem = function BillCalculatorItem(_ref6) {
  var _ref6$deduct = _ref6.deduct,
    deduct = _ref6$deduct === void 0 ? false : _ref6$deduct,
    unitPrice = _ref6.unitPrice,
    interval = _ref6.interval,
    quantity = _ref6.quantity,
    subtotal = _ref6.subtotal;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  var sign = deduct ? '-' : '';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('py-3 flex justify-between first:border-t border-b items-center', {
      'text-red': deduct
    })
  }, /*#__PURE__*/_react["default"].createElement("div", null, "".concat(sign).concat(unitPrice, " ").concat(t("premium.billCalculator.interval.".concat(interval)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-sm', {
      'text-light': !deduct,
      'text-red': deduct
    })
  }, t('premium.billCalculator.numUsers', {
    count: quantity
  })), /*#__PURE__*/_react["default"].createElement("div", null, "".concat(sign).concat(subtotal)));
};
var BillCalculatorTotal = exports.BillCalculatorTotal = function BillCalculatorTotal(_ref7) {
  var dueDate = _ref7.dueDate,
    amount = _ref7.amount;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-10 flex justify-between font-bold"
  }, /*#__PURE__*/_react["default"].createElement("div", null, t('premium.billCalculator.dueDate', {
    dueDate: dueDate
  })), /*#__PURE__*/_react["default"].createElement("div", null, amount));
};
var _default = exports["default"] = PaymentWithCalculator;
//# sourceMappingURL=PaymentWithCalculator.js.map